var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "table" },
    [
      _c(
        "div",
        { staticClass: "container" },
        [
          _c(
            "div",
            { staticClass: "handle-box" },
            [
              _c(
                "el-form",
                {
                  ref: "queryCondition",
                  staticClass: "searchForm",
                  attrs: {
                    model: _vm.queryCondition,
                    "label-position": _vm.labelPosition,
                    "label-width": "120px",
                  },
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20, type: "flex", align: "middle" } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "年份", prop: "year" } },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "value-format": "yyyy",
                                  format: "yyyy",
                                  type: "year",
                                  placeholder: "选择年",
                                },
                                on: { change: _vm.yearChange },
                                model: {
                                  value: _vm.year,
                                  callback: function ($$v) {
                                    _vm.year = $$v
                                  },
                                  expression: "year",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "季度", prop: "quarter" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { placeholder: "请选择" },
                                  on: { change: _vm.quarterChange },
                                  model: {
                                    value: _vm.quarter,
                                    callback: function ($$v) {
                                      _vm.quarter = $$v
                                    },
                                    expression: "quarter",
                                  },
                                },
                                _vm._l(
                                  _vm.quarterOptions,
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.label,
                                        value: item.key,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "月份", prop: "month" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { placeholder: "请选择" },
                                  model: {
                                    value: _vm.month,
                                    callback: function ($$v) {
                                      _vm.month = $$v
                                    },
                                    expression: "month",
                                  },
                                },
                                _vm._l(
                                  _vm.monthOptions,
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.label,
                                        value: item.key,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  staticClass: "btn",
                                  attrs: { size: "mini", type: "primary" },
                                  on: { click: _vm.onAdd },
                                },
                                [_vm._v("新增评价期")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20, type: "flex", align: "middle" } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "评价时间",
                                prop: "ratingPeriod",
                              },
                            },
                            [
                              _c("el-input", {
                                staticStyle: { width: "100%" },
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.queryCondition.ratingPeriod,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryCondition,
                                      "ratingPeriod",
                                      $$v
                                    )
                                  },
                                  expression: "queryCondition.ratingPeriod",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "对比评价时间",
                                prop: "peerRatingPeriod",
                              },
                            },
                            [
                              _c("el-input", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  disabled: "",
                                  type: "textarea",
                                  autosize: { minRows: 1, maxRows: 4 },
                                },
                                model: {
                                  value: _vm.queryCondition.peerRatingPeriod,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryCondition,
                                      "peerRatingPeriod",
                                      $$v
                                    )
                                  },
                                  expression: "queryCondition.peerRatingPeriod",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  staticClass: "btn",
                                  attrs: { size: "mini", type: "primary" },
                                  on: { click: _vm.onContrast },
                                },
                                [_vm._v("新增对比评价期")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20, type: "flex", justify: "center" } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini", type: "primary" },
                          on: { click: _vm.onSearch },
                        },
                        [_vm._v("查询")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini", type: "primary" },
                          on: { click: _vm.onReset },
                        },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "action-btn-row" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.onExport },
                },
                [_vm._v("导出")]
              ),
            ],
            1
          ),
          _c("el-row", [
            _c("div", { staticClass: "title_box" }, [
              _c("p", { staticClass: "line" }),
              _c("p", { staticClass: "title" }, [
                _vm._v("Monthly analysis (%)"),
              ]),
            ]),
          ]),
          _vm._l(_vm.tableLists, function (item, index) {
            return _c(
              "div",
              {
                key: index,
                staticStyle: {
                  width: "100%",
                  overflow: "auto",
                  "margin-bottom": "15px",
                },
              },
              [
                _c("table", { staticClass: "table" }, [
                  _c("tr", [
                    _c(
                      "td",
                      {
                        staticClass: "table_td",
                        staticStyle: { width: "80px" },
                      },
                      [_vm._v("评价时间")]
                    ),
                    _c(
                      "td",
                      {
                        staticClass: "table_td",
                        staticStyle: { width: "90px" },
                      },
                      [_vm._v("对比评价时间")]
                    ),
                    _c(
                      "td",
                      {
                        staticClass: "table_td",
                        staticStyle: { width: "70px" },
                      },
                      [_vm._v("Grade")]
                    ),
                    _c(
                      "td",
                      {
                        staticClass: "table_td",
                        staticStyle: { width: "70px" },
                      },
                      [_vm._v("AAA")]
                    ),
                    _c(
                      "td",
                      {
                        staticClass: "table_td",
                        staticStyle: { width: "70px" },
                      },
                      [_vm._v("QBR")]
                    ),
                    _c(
                      "td",
                      {
                        staticClass: "table_td",
                        staticStyle: { width: "70px" },
                      },
                      [_vm._v("MSV")]
                    ),
                    _c(
                      "td",
                      {
                        staticClass: "table_td",
                        staticStyle: { width: "70px" },
                      },
                      [_vm._v(_vm._s(_vm.labelName))]
                    ),
                    _c(
                      "td",
                      {
                        staticClass: "table_td",
                        staticStyle: { width: "70px" },
                      },
                      [_vm._v("SQMS")]
                    ),
                    _c(
                      "td",
                      {
                        staticClass: "table_td",
                        staticStyle: { width: "100px" },
                      },
                      [_vm._v("Gov`t Cert")]
                    ),
                    _c(
                      "td",
                      {
                        staticClass: "table_td",
                        staticStyle: { width: "120px" },
                      },
                      [_vm._v("Spec Compliance")]
                    ),
                    _c(
                      "td",
                      {
                        staticClass: "table_td",
                        staticStyle: { width: "70px" },
                      },
                      [_vm._v("COA")]
                    ),
                    _c(
                      "td",
                      {
                        staticClass: "table_td",
                        staticStyle: { width: "120px" },
                      },
                      [_vm._v("Reg Compliance")]
                    ),
                    _c(
                      "td",
                      {
                        staticClass: "table_td",
                        staticStyle: { width: "120px" },
                      },
                      [_vm._v("Gov`t Plant Audit")]
                    ),
                    _c(
                      "td",
                      {
                        staticClass: "table_td",
                        staticStyle: { width: "120px" },
                      },
                      [_vm._v("Stock Recovery")]
                    ),
                    _c(
                      "td",
                      {
                        staticClass: "table_td",
                        staticStyle: { width: "70px" },
                      },
                      [_vm._v("QIP")]
                    ),
                    _c(
                      "td",
                      {
                        staticClass: "table_td",
                        staticStyle: { width: "120px" },
                      },
                      [_vm._v("Product Feedback")]
                    ),
                    _c(
                      "td",
                      {
                        staticClass: "table_td",
                        staticStyle: { width: "70px" },
                      },
                      [_vm._v("Sensory")]
                    ),
                    _c(
                      "td",
                      {
                        staticClass: "table_td",
                        staticStyle: { width: "140px" },
                      },
                      [_vm._v("Consumer Feedback")]
                    ),
                    _c(
                      "td",
                      {
                        staticClass: "table_td",
                        staticStyle: { width: "70px" },
                      },
                      [_vm._v("DQMP")]
                    ),
                    _c(
                      "td",
                      {
                        staticClass: "table_td",
                        staticStyle: { width: "120px" },
                      },
                      [_vm._v("RMC Chicken")]
                    ),
                    _c(
                      "td",
                      {
                        staticClass: "table_td",
                        staticStyle: { width: "120px" },
                      },
                      [_vm._v("RMC Produce")]
                    ),
                    _c(
                      "td",
                      {
                        staticClass: "table_td",
                        staticStyle: { width: "120px" },
                      },
                      [_vm._v("Antibiotic Chicken")]
                    ),
                  ]),
                  _c("tr", [
                    _c("td", { staticStyle: { width: "80px" } }, [
                      _vm._v(_vm._s(item.abPerformanceInfo.period)),
                    ]),
                    _c("td", { staticStyle: { width: "90px" } }),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      _vm._v("A+B"),
                    ]),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (item.abPerformanceInfo.aaa * 100).toPrecision(
                                  12
                                )
                              )
                            )
                          ) + "%"
                        ),
                      ]),
                    ]),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (item.abPerformanceInfo.qbr * 100).toPrecision(
                                  12
                                )
                              )
                            )
                          ) + "%"
                        ),
                      ]),
                    ]),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (item.abPerformanceInfo.msv * 100).toPrecision(
                                  12
                                )
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (item.abPerformanceInfo.swa * 100).toPrecision(
                                  12
                                )
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (item.abPerformanceInfo.sqms * 100).toPrecision(
                                  12
                                )
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "100px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.abPerformanceInfo.govtCert * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "120px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.abPerformanceInfo.specComp * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (item.abPerformanceInfo.coa * 100).toPrecision(
                                  12
                                )
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "120px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.abPerformanceInfo.regComp * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "120px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.abPerformanceInfo.govtPlant * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "120px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.abPerformanceInfo.stockRecovery * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (item.abPerformanceInfo.qip * 100).toPrecision(
                                  12
                                )
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "120px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.abPerformanceInfo.feedback * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.abPerformanceInfo.sensory * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "140px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.abPerformanceInfo.consumerFeedback * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (item.abPerformanceInfo.dqmp * 100).toPrecision(
                                  12
                                )
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "120px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.abPerformanceInfo.rmcChick * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "120px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.abPerformanceInfo.rmcProduce * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "120px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.abPerformanceInfo.antiChick * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                  ]),
                  _c("tr", [
                    _c("td", { staticStyle: { width: "80px" } }),
                    _c("td", { staticStyle: { width: "90px" } }, [
                      _vm._v(_vm._s(item.peerAbPerformanceInfo.period)),
                    ]),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      _vm._v("A+B"),
                    ]),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.peerAbPerformanceInfo.aaa * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.peerAbPerformanceInfo.qbr * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.peerAbPerformanceInfo.msv * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.peerAbPerformanceInfo.swa * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.peerAbPerformanceInfo.sqms * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "100px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.peerAbPerformanceInfo.govtCert * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "120px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.peerAbPerformanceInfo.specComp * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.peerAbPerformanceInfo.coa * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "120px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.peerAbPerformanceInfo.regComp * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "120px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.peerAbPerformanceInfo.govtPlant * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "120px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.peerAbPerformanceInfo.stockRecovery * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.peerAbPerformanceInfo.qip * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "120px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.peerAbPerformanceInfo.feedback * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.peerAbPerformanceInfo.sensory * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "140px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.peerAbPerformanceInfo.consumerFeedback *
                                  100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.peerAbPerformanceInfo.dqmp * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "120px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.peerAbPerformanceInfo.rmcChick * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "120px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.peerAbPerformanceInfo.rmcProduce * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "120px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.peerAbPerformanceInfo.antiChick * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                  ]),
                  _c("tr", [
                    _c(
                      "td",
                      {
                        staticClass: "table_td_grade",
                        staticStyle: { width: "170px" },
                        attrs: { colspan: 2 },
                        on: {
                          click: function ($event) {
                            return _vm.abClick(item)
                          },
                        },
                      },
                      [_vm._v("Grade A+B 趋势")]
                    ),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      _vm._v("A+B"),
                    ]),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      Number(item.abTrend.aaa) > 0
                        ? _c("i", { staticClass: "el-icon-top redClass" })
                        : _vm._e(),
                      Number(item.abTrend.aaa) >= 0
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  Math.round(
                                    parseFloat(
                                      (item.abTrend.aaa * 100).toPrecision(12)
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                      Number(item.abTrend.aaa) < 0
                        ? _c("i", { staticClass: "el-icon-bottom greenClass" })
                        : _vm._e(),
                      Number(item.abTrend.aaa) < 0
                        ? _c("span", [
                            _vm._v(
                              " -" +
                                _vm._s(
                                  Math.round(
                                    Math.abs(
                                      parseFloat(
                                        (item.abTrend.aaa * 100).toPrecision(12)
                                      )
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      Number(item.abTrend.qbr) > 0
                        ? _c("i", { staticClass: "el-icon-top redClass" })
                        : _vm._e(),
                      Number(item.abTrend.qbr) >= 0
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  Math.round(
                                    parseFloat(
                                      (item.abTrend.qbr * 100).toPrecision(12)
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                      Number(item.abTrend.qbr) < 0
                        ? _c("i", { staticClass: "el-icon-bottom greenClass" })
                        : _vm._e(),
                      Number(item.abTrend.qbr) < 0
                        ? _c("span", [
                            _vm._v(
                              " -" +
                                _vm._s(
                                  Math.round(
                                    Math.abs(
                                      parseFloat(
                                        (item.abTrend.qbr * 100).toPrecision(12)
                                      )
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      Number(item.abTrend.msv) > 0
                        ? _c("i", { staticClass: "el-icon-top redClass" })
                        : _vm._e(),
                      Number(item.abTrend.msv) >= 0
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  Math.round(
                                    parseFloat(
                                      (item.abTrend.msv * 100).toPrecision(12)
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                      Number(item.abTrend.msv) < 0
                        ? _c("i", { staticClass: "el-icon-bottom greenClass" })
                        : _vm._e(),
                      Number(item.abTrend.msv) < 0
                        ? _c("span", [
                            _vm._v(
                              " -" +
                                _vm._s(
                                  Math.round(
                                    Math.abs(
                                      parseFloat(
                                        (item.abTrend.msv * 100).toPrecision(12)
                                      )
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      Number(item.abTrend.swa) > 0
                        ? _c("i", { staticClass: "el-icon-top redClass" })
                        : _vm._e(),
                      Number(item.abTrend.swa) >= 0
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  Math.round(
                                    parseFloat(
                                      (item.abTrend.swa * 100).toPrecision(12)
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                      Number(item.abTrend.swa) < 0
                        ? _c("i", { staticClass: "el-icon-bottom greenClass" })
                        : _vm._e(),
                      Number(item.abTrend.swa) < 0
                        ? _c("span", [
                            _vm._v(
                              " -" +
                                _vm._s(
                                  Math.round(
                                    Math.abs(
                                      parseFloat(
                                        (item.abTrend.swa * 100).toPrecision(12)
                                      )
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      Number(item.abTrend.sqms) > 0
                        ? _c("i", { staticClass: "el-icon-top redClass" })
                        : _vm._e(),
                      Number(item.abTrend.sqms) >= 0
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  Math.round(
                                    parseFloat(
                                      (item.abTrend.sqms * 100).toPrecision(12)
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                      Number(item.abTrend.sqms) < 0
                        ? _c("i", { staticClass: "el-icon-bottom greenClass" })
                        : _vm._e(),
                      Number(item.abTrend.sqms) < 0
                        ? _c("span", [
                            _vm._v(
                              " -" +
                                _vm._s(
                                  Math.round(
                                    Math.abs(
                                      parseFloat(
                                        (item.abTrend.sqms * 100).toPrecision(
                                          12
                                        )
                                      )
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _c("td", { staticStyle: { width: "100px" } }, [
                      Number(item.abTrend.govtCert) > 0
                        ? _c("i", { staticClass: "el-icon-top redClass" })
                        : _vm._e(),
                      Number(item.abTrend.govtCert) >= 0
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  Math.round(
                                    parseFloat(
                                      (item.abTrend.govtCert * 100).toPrecision(
                                        12
                                      )
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                      Number(item.abTrend.govtCert) < 0
                        ? _c("i", { staticClass: "el-icon-bottom greenClass" })
                        : _vm._e(),
                      Number(item.abTrend.govtCert) < 0
                        ? _c("span", [
                            _vm._v(
                              " -" +
                                _vm._s(
                                  Math.round(
                                    Math.abs(
                                      parseFloat(
                                        (
                                          item.abTrend.govtCert * 100
                                        ).toPrecision(12)
                                      )
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _c("td", { staticStyle: { width: "120px" } }, [
                      Number(item.abTrend.specComp) > 0
                        ? _c("i", { staticClass: "el-icon-top redClass" })
                        : _vm._e(),
                      Number(item.abTrend.specComp) >= 0
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  Math.round(
                                    parseFloat(
                                      (item.abTrend.specComp * 100).toPrecision(
                                        12
                                      )
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                      Number(item.abTrend.specComp) < 0
                        ? _c("i", { staticClass: "el-icon-bottom greenClass" })
                        : _vm._e(),
                      Number(item.abTrend.specComp) < 0
                        ? _c("span", [
                            _vm._v(
                              " -" +
                                _vm._s(
                                  Math.round(
                                    Math.abs(
                                      parseFloat(
                                        (
                                          item.abTrend.specComp * 100
                                        ).toPrecision(12)
                                      )
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      Number(item.abTrend.coa) > 0
                        ? _c("i", { staticClass: "el-icon-top redClass" })
                        : _vm._e(),
                      Number(item.abTrend.coa) >= 0
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  Math.round(
                                    parseFloat(
                                      (item.abTrend.coa * 100).toPrecision(12)
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                      Number(item.abTrend.coa) < 0
                        ? _c("i", { staticClass: "el-icon-bottom greenClass" })
                        : _vm._e(),
                      Number(item.abTrend.coa) < 0
                        ? _c("span", [
                            _vm._v(
                              " -" +
                                _vm._s(
                                  Math.round(
                                    Math.abs(
                                      parseFloat(
                                        (item.abTrend.coa * 100).toPrecision(12)
                                      )
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _c("td", { staticStyle: { width: "120px" } }, [
                      Number(item.abTrend.regComp) > 0
                        ? _c("i", { staticClass: "el-icon-top redClass" })
                        : _vm._e(),
                      Number(item.abTrend.regComp) >= 0
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  Math.round(
                                    parseFloat(
                                      (item.abTrend.regComp * 100).toPrecision(
                                        12
                                      )
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                      Number(item.abTrend.regComp) < 0
                        ? _c("i", { staticClass: "el-icon-bottom greenClass" })
                        : _vm._e(),
                      Number(item.abTrend.regComp) < 0
                        ? _c("span", [
                            _vm._v(
                              " -" +
                                _vm._s(
                                  Math.round(
                                    Math.abs(
                                      parseFloat(
                                        (
                                          item.abTrend.regComp * 100
                                        ).toPrecision(12)
                                      )
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _c("td", { staticStyle: { width: "120px" } }, [
                      Number(item.abTrend.govtPlant) > 0
                        ? _c("i", { staticClass: "el-icon-top redClass" })
                        : _vm._e(),
                      Number(item.abTrend.govtPlant) >= 0
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  Math.round(
                                    parseFloat(
                                      (
                                        item.abTrend.govtPlant * 100
                                      ).toPrecision(12)
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                      Number(item.abTrend.govtPlant) < 0
                        ? _c("i", { staticClass: "el-icon-bottom greenClass" })
                        : _vm._e(),
                      Number(item.abTrend.govtPlant) < 0
                        ? _c("span", [
                            _vm._v(
                              " -" +
                                _vm._s(
                                  Math.round(
                                    Math.abs(
                                      parseFloat(
                                        (
                                          item.abTrend.govtPlant * 100
                                        ).toPrecision(12)
                                      )
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _c("td", { staticStyle: { width: "120px" } }, [
                      Number(item.abTrend.stockRecovery) > 0
                        ? _c("i", { staticClass: "el-icon-top redClass" })
                        : _vm._e(),
                      Number(item.abTrend.stockRecovery) >= 0
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  Math.round(
                                    parseFloat(
                                      (
                                        item.abTrend.stockRecovery * 100
                                      ).toPrecision(12)
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                      Number(item.abTrend.stockRecovery) < 0
                        ? _c("i", { staticClass: "el-icon-bottom greenClass" })
                        : _vm._e(),
                      Number(item.abTrend.stockRecovery) < 0
                        ? _c("span", [
                            _vm._v(
                              " -" +
                                _vm._s(
                                  Math.round(
                                    Math.abs(
                                      parseFloat(
                                        (
                                          item.abTrend.stockRecovery * 100
                                        ).toPrecision(12)
                                      )
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      Number(item.abTrend.qip) > 0
                        ? _c("i", { staticClass: "el-icon-top redClass" })
                        : _vm._e(),
                      Number(item.abTrend.qip) >= 0
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  Math.round(
                                    parseFloat(
                                      (item.abTrend.qip * 100).toPrecision(12)
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                      Number(item.abTrend.qip) < 0
                        ? _c("i", { staticClass: "el-icon-bottom greenClass" })
                        : _vm._e(),
                      Number(item.abTrend.qip) < 0
                        ? _c("span", [
                            _vm._v(
                              " -" +
                                _vm._s(
                                  Math.round(
                                    Math.abs(
                                      parseFloat(
                                        (item.abTrend.qip * 100).toPrecision(12)
                                      )
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _c("td", { staticStyle: { width: "120px" } }, [
                      Number(item.abTrend.feedback) > 0
                        ? _c("i", { staticClass: "el-icon-top redClass" })
                        : _vm._e(),
                      Number(item.abTrend.feedback) >= 0
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  Math.round(
                                    parseFloat(
                                      (item.abTrend.feedback * 100).toPrecision(
                                        12
                                      )
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                      Number(item.abTrend.feedback) < 0
                        ? _c("i", { staticClass: "el-icon-bottom greenClass" })
                        : _vm._e(),
                      Number(item.abTrend.feedback) < 0
                        ? _c("span", [
                            _vm._v(
                              " -" +
                                _vm._s(
                                  Math.round(
                                    Math.abs(
                                      parseFloat(
                                        (
                                          item.abTrend.feedback * 100
                                        ).toPrecision(12)
                                      )
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      Number(item.abTrend.sensory) > 0
                        ? _c("i", { staticClass: "el-icon-top redClass" })
                        : _vm._e(),
                      Number(item.abTrend.sensory) >= 0
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  Math.round(
                                    parseFloat(
                                      (item.abTrend.sensory * 100).toPrecision(
                                        12
                                      )
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                      Number(item.abTrend.sensory) < 0
                        ? _c("i", { staticClass: "el-icon-bottom greenClass" })
                        : _vm._e(),
                      Number(item.abTrend.sensory) < 0
                        ? _c("span", [
                            _vm._v(
                              " -" +
                                _vm._s(
                                  Math.round(
                                    Math.abs(
                                      parseFloat(
                                        (
                                          item.abTrend.sensory * 100
                                        ).toPrecision(12)
                                      )
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _c("td", { staticStyle: { width: "140px" } }, [
                      Number(item.abTrend.consumerFeedback) > 0
                        ? _c("i", { staticClass: "el-icon-top redClass" })
                        : _vm._e(),
                      Number(item.abTrend.consumerFeedback) >= 0
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  Math.round(
                                    parseFloat(
                                      (
                                        item.abTrend.consumerFeedback * 100
                                      ).toPrecision(12)
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                      Number(item.abTrend.consumerFeedback) < 0
                        ? _c("i", { staticClass: "el-icon-bottom greenClass" })
                        : _vm._e(),
                      Number(item.abTrend.consumerFeedback) < 0
                        ? _c("span", [
                            _vm._v(
                              " -" +
                                _vm._s(
                                  Math.round(
                                    Math.abs(
                                      parseFloat(
                                        (
                                          item.abTrend.consumerFeedback * 100
                                        ).toPrecision(12)
                                      )
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      Number(item.abTrend.dqmp) > 0
                        ? _c("i", { staticClass: "el-icon-top redClass" })
                        : _vm._e(),
                      Number(item.abTrend.dqmp) >= 0
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  Math.round(
                                    parseFloat(
                                      (item.abTrend.dqmp * 100).toPrecision(12)
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                      Number(item.abTrend.dqmp) < 0
                        ? _c("i", { staticClass: "el-icon-bottom greenClass" })
                        : _vm._e(),
                      Number(item.abTrend.dqmp) < 0
                        ? _c("span", [
                            _vm._v(
                              " -" +
                                _vm._s(
                                  Math.round(
                                    Math.abs(
                                      parseFloat(
                                        (item.abTrend.dqmp * 100).toPrecision(
                                          12
                                        )
                                      )
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _c("td", { staticStyle: { width: "120px" } }, [
                      Number(item.abTrend.rmcChick) > 0
                        ? _c("i", { staticClass: "el-icon-top redClass" })
                        : _vm._e(),
                      Number(item.abTrend.rmcChick) >= 0
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  Math.round(
                                    parseFloat(
                                      (item.abTrend.rmcChick * 100).toPrecision(
                                        12
                                      )
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                      Number(item.abTrend.rmcChick) < 0
                        ? _c("i", { staticClass: "el-icon-bottom greenClass" })
                        : _vm._e(),
                      Number(item.abTrend.rmcChick) < 0
                        ? _c("span", [
                            _vm._v(
                              " -" +
                                _vm._s(
                                  Math.round(
                                    Math.abs(
                                      parseFloat(
                                        (
                                          item.abTrend.rmcChick * 100
                                        ).toPrecision(12)
                                      )
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _c("td", { staticStyle: { width: "120px" } }, [
                      Number(item.abTrend.rmcProduce) > 0
                        ? _c("i", { staticClass: "el-icon-top redClass" })
                        : _vm._e(),
                      Number(item.abTrend.rmcProduce) >= 0
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  Math.round(
                                    parseFloat(
                                      (
                                        item.abTrend.rmcProduce * 100
                                      ).toPrecision(12)
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                      Number(item.abTrend.rmcProduce) < 0
                        ? _c("i", { staticClass: "el-icon-bottom greenClass" })
                        : _vm._e(),
                      Number(item.abTrend.rmcProduce) < 0
                        ? _c("span", [
                            _vm._v(
                              " -" +
                                _vm._s(
                                  Math.round(
                                    Math.abs(
                                      parseFloat(
                                        (
                                          item.abTrend.rmcProduce * 100
                                        ).toPrecision(12)
                                      )
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _c("td", { staticStyle: { width: "120px" } }, [
                      Number(item.abTrend.antiChick) > 0
                        ? _c("i", { staticClass: "el-icon-top redClass" })
                        : _vm._e(),
                      Number(item.abTrend.antiChick) >= 0
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  Math.round(
                                    parseFloat(
                                      (
                                        item.abTrend.antiChick * 100
                                      ).toPrecision(12)
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                      Number(item.abTrend.antiChick) < 0
                        ? _c("i", { staticClass: "el-icon-bottom greenClass" })
                        : _vm._e(),
                      Number(item.abTrend.antiChick) < 0
                        ? _c("span", [
                            _vm._v(
                              " -" +
                                _vm._s(
                                  Math.round(
                                    Math.abs(
                                      parseFloat(
                                        (
                                          item.abTrend.antiChick * 100
                                        ).toPrecision(12)
                                      )
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                  _c("tr", [
                    _c("td", { staticStyle: { width: "80px" } }, [
                      _vm._v(_vm._s(item.dPerformanceInfo.period)),
                    ]),
                    _c("td", { staticStyle: { width: "90px" } }),
                    _c("td", { staticStyle: { width: "70px" } }, [_vm._v("D")]),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (item.dPerformanceInfo.aaa * 100).toPrecision(
                                  12
                                )
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (item.dPerformanceInfo.qbr * 100).toPrecision(
                                  12
                                )
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (item.dPerformanceInfo.msv * 100).toPrecision(
                                  12
                                )
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (item.dPerformanceInfo.swa * 100).toPrecision(
                                  12
                                )
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (item.dPerformanceInfo.sqms * 100).toPrecision(
                                  12
                                )
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "100px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.dPerformanceInfo.govtCert * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "120px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.dPerformanceInfo.specComp * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (item.dPerformanceInfo.coa * 100).toPrecision(
                                  12
                                )
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "120px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.dPerformanceInfo.regComp * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "120px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.dPerformanceInfo.govtPlant * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "120px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.dPerformanceInfo.stockRecovery * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (item.dPerformanceInfo.qip * 100).toPrecision(
                                  12
                                )
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "120px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.dPerformanceInfo.feedback * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.dPerformanceInfo.sensory * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "140px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.dPerformanceInfo.consumerFeedback * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (item.dPerformanceInfo.dqmp * 100).toPrecision(
                                  12
                                )
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "120px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.dPerformanceInfo.rmcChick * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "120px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.dPerformanceInfo.rmcProduce * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "120px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.dPerformanceInfo.antiChick * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                  ]),
                  _c("tr", [
                    _c("td", { staticStyle: { width: "80px" } }),
                    _c("td", { staticStyle: { width: "90px" } }, [
                      _vm._v(_vm._s(item.peerDPerformanceInfo.period)),
                    ]),
                    _c("td", { staticStyle: { width: "70px" } }, [_vm._v("D")]),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.peerDPerformanceInfo.aaa * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.peerDPerformanceInfo.qbr * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.peerDPerformanceInfo.msv * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.peerDPerformanceInfo.swa * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.peerDPerformanceInfo.sqms * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "100px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.peerDPerformanceInfo.govtCert * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "120px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.peerDPerformanceInfo.specComp * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.peerDPerformanceInfo.coa * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "120px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.peerDPerformanceInfo.regComp * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "120px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.peerDPerformanceInfo.govtPlant * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "120px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.peerDPerformanceInfo.stockRecovery * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.peerDPerformanceInfo.qip * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "120px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.peerDPerformanceInfo.feedback * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.peerDPerformanceInfo.sensory * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "140px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.peerDPerformanceInfo.consumerFeedback *
                                  100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.peerDPerformanceInfo.dqmp * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "120px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.peerDPerformanceInfo.rmcChick * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "120px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.peerDPerformanceInfo.rmcProduce * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                    _c("td", { staticStyle: { width: "120px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            Math.round(
                              parseFloat(
                                (
                                  item.peerDPerformanceInfo.antiChick * 100
                                ).toPrecision(12)
                              )
                            )
                          ) +
                          "% "
                      ),
                    ]),
                  ]),
                  _c("tr", [
                    _c(
                      "td",
                      {
                        staticClass: "table_td_grade",
                        staticStyle: { width: "170px" },
                        attrs: { colspan: 2 },
                        on: {
                          click: function ($event) {
                            return _vm.dClick(item)
                          },
                        },
                      },
                      [_vm._v("Grade D 趋势")]
                    ),
                    _c("td", { staticStyle: { width: "70px" } }, [_vm._v("D")]),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      Number(item.dTrend.aaa) > 0
                        ? _c("i", { staticClass: "el-icon-top redClass" })
                        : _vm._e(),
                      Number(item.dTrend.aaa) >= 0
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  Math.round(
                                    parseFloat(
                                      (item.dTrend.aaa * 100).toPrecision(12)
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                      Number(item.dTrend.aaa) < 0
                        ? _c("i", { staticClass: "el-icon-bottom greenClass" })
                        : _vm._e(),
                      Number(item.dTrend.aaa) < 0
                        ? _c("span", [
                            _vm._v(
                              " -" +
                                _vm._s(
                                  Math.round(
                                    Math.abs(
                                      parseFloat(
                                        (item.dTrend.aaa * 100).toPrecision(12)
                                      )
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      Number(item.dTrend.qbr) > 0
                        ? _c("i", { staticClass: "el-icon-top redClass" })
                        : _vm._e(),
                      Number(item.dTrend.qbr) >= 0
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  Math.round(
                                    parseFloat(
                                      (item.dTrend.qbr * 100).toPrecision(12)
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                      Number(item.dTrend.qbr) < 0
                        ? _c("i", { staticClass: "el-icon-bottom greenClass" })
                        : _vm._e(),
                      Number(item.dTrend.qbr) < 0
                        ? _c("span", [
                            _vm._v(
                              " -" +
                                _vm._s(
                                  Math.round(
                                    Math.abs(
                                      parseFloat(
                                        (item.dTrend.qbr * 100).toPrecision(12)
                                      )
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      Number(item.dTrend.msv) > 0
                        ? _c("i", { staticClass: "el-icon-top redClass" })
                        : _vm._e(),
                      Number(item.dTrend.msv) >= 0
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  Math.round(
                                    parseFloat(
                                      (item.dTrend.msv * 100).toPrecision(12)
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                      Number(item.dTrend.msv) < 0
                        ? _c("i", { staticClass: "el-icon-bottom greenClass" })
                        : _vm._e(),
                      Number(item.dTrend.msv) < 0
                        ? _c("span", [
                            _vm._v(
                              " -" +
                                _vm._s(
                                  Math.round(
                                    Math.abs(
                                      parseFloat(
                                        (item.dTrend.msv * 100).toPrecision(12)
                                      )
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      Number(item.dTrend.swa) > 0
                        ? _c("i", { staticClass: "el-icon-top redClass" })
                        : _vm._e(),
                      Number(item.dTrend.swa) >= 0
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  Math.round(
                                    parseFloat(
                                      (item.dTrend.swa * 100).toPrecision(12)
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                      Number(item.dTrend.swa) < 0
                        ? _c("i", { staticClass: "el-icon-bottom greenClass" })
                        : _vm._e(),
                      Number(item.dTrend.swa) < 0
                        ? _c("span", [
                            _vm._v(
                              " -" +
                                _vm._s(
                                  Math.round(
                                    Math.abs(
                                      parseFloat(
                                        (item.dTrend.swa * 100).toPrecision(12)
                                      )
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      Number(item.dTrend.sqms) > 0
                        ? _c("i", { staticClass: "el-icon-top redClass" })
                        : _vm._e(),
                      Number(item.dTrend.sqms) >= 0
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  Math.round(
                                    parseFloat(
                                      (item.dTrend.sqms * 100).toPrecision(12)
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                      Number(item.dTrend.sqms) < 0
                        ? _c("i", { staticClass: "el-icon-bottom greenClass" })
                        : _vm._e(),
                      Number(item.dTrend.sqms) < 0
                        ? _c("span", [
                            _vm._v(
                              " -" +
                                _vm._s(
                                  Math.round(
                                    Math.abs(
                                      parseFloat(
                                        (item.dTrend.sqms * 100).toPrecision(12)
                                      )
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _c("td", { staticStyle: { width: "100px" } }, [
                      Number(item.dTrend.govtCert) > 0
                        ? _c("i", { staticClass: "el-icon-top redClass" })
                        : _vm._e(),
                      Number(item.dTrend.govtCert) >= 0
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  Math.round(
                                    parseFloat(
                                      (item.dTrend.govtCert * 100).toPrecision(
                                        12
                                      )
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                      Number(item.dTrend.govtCert) < 0
                        ? _c("i", { staticClass: "el-icon-bottom greenClass" })
                        : _vm._e(),
                      Number(item.dTrend.govtCert) < 0
                        ? _c("span", [
                            _vm._v(
                              " -" +
                                _vm._s(
                                  Math.round(
                                    Math.abs(
                                      parseFloat(
                                        (
                                          item.dTrend.govtCert * 100
                                        ).toPrecision(12)
                                      )
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _c("td", { staticStyle: { width: "120px" } }, [
                      Number(item.dTrend.specComp) > 0
                        ? _c("i", { staticClass: "el-icon-top redClass" })
                        : _vm._e(),
                      Number(item.dTrend.specComp) >= 0
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  Math.round(
                                    parseFloat(
                                      (item.dTrend.specComp * 100).toPrecision(
                                        12
                                      )
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                      Number(item.dTrend.specComp) < 0
                        ? _c("i", { staticClass: "el-icon-bottom greenClass" })
                        : _vm._e(),
                      Number(item.dTrend.specComp) < 0
                        ? _c("span", [
                            _vm._v(
                              " -" +
                                _vm._s(
                                  Math.round(
                                    Math.abs(
                                      parseFloat(
                                        (
                                          item.dTrend.specComp * 100
                                        ).toPrecision(12)
                                      )
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      Number(item.dTrend.coa) > 0
                        ? _c("i", { staticClass: "el-icon-top redClass" })
                        : _vm._e(),
                      Number(item.dTrend.coa) >= 0
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  Math.round(
                                    parseFloat(
                                      (item.dTrend.coa * 100).toPrecision(12)
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                      Number(item.dTrend.coa) < 0
                        ? _c("i", { staticClass: "el-icon-bottom greenClass" })
                        : _vm._e(),
                      Number(item.dTrend.coa) < 0
                        ? _c("span", [
                            _vm._v(
                              " -" +
                                _vm._s(
                                  Math.round(
                                    Math.abs(
                                      parseFloat(
                                        (item.dTrend.coa * 100).toPrecision(12)
                                      )
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _c("td", { staticStyle: { width: "120px" } }, [
                      Number(item.dTrend.regComp) > 0
                        ? _c("i", { staticClass: "el-icon-top redClass" })
                        : _vm._e(),
                      Number(item.dTrend.regComp) >= 0
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  Math.round(
                                    parseFloat(
                                      (item.dTrend.regComp * 100).toPrecision(
                                        12
                                      )
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                      Number(item.dTrend.regComp) < 0
                        ? _c("i", { staticClass: "el-icon-bottom greenClass" })
                        : _vm._e(),
                      Number(item.dTrend.regComp) < 0
                        ? _c("span", [
                            _vm._v(
                              " -" +
                                _vm._s(
                                  Math.round(
                                    Math.abs(
                                      parseFloat(
                                        (item.dTrend.regComp * 100).toPrecision(
                                          12
                                        )
                                      )
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _c("td", { staticStyle: { width: "120px" } }, [
                      Number(item.dTrend.govtPlant) > 0
                        ? _c("i", { staticClass: "el-icon-top redClass" })
                        : _vm._e(),
                      Number(item.dTrend.govtPlant) >= 0
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  Math.round(
                                    parseFloat(
                                      (item.dTrend.govtPlant * 100).toPrecision(
                                        12
                                      )
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                      Number(item.dTrend.govtPlant) < 0
                        ? _c("i", { staticClass: "el-icon-bottom greenClass" })
                        : _vm._e(),
                      Number(item.dTrend.govtPlant) < 0
                        ? _c("span", [
                            _vm._v(
                              " -" +
                                _vm._s(
                                  Math.round(
                                    Math.abs(
                                      parseFloat(
                                        (
                                          item.dTrend.govtPlant * 100
                                        ).toPrecision(12)
                                      )
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _c("td", { staticStyle: { width: "120px" } }, [
                      Number(item.dTrend.stockRecovery) > 0
                        ? _c("i", { staticClass: "el-icon-top redClass" })
                        : _vm._e(),
                      Number(item.dTrend.stockRecovery) >= 0
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  Math.round(
                                    parseFloat(
                                      (
                                        item.dTrend.stockRecovery * 100
                                      ).toPrecision(12)
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                      Number(item.dTrend.stockRecovery) < 0
                        ? _c("i", { staticClass: "el-icon-bottom greenClass" })
                        : _vm._e(),
                      Number(item.dTrend.stockRecovery) < 0
                        ? _c("span", [
                            _vm._v(
                              " -" +
                                _vm._s(
                                  Math.round(
                                    Math.abs(
                                      parseFloat(
                                        (
                                          item.dTrend.stockRecovery * 100
                                        ).toPrecision(12)
                                      )
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      Number(item.dTrend.qip) > 0
                        ? _c("i", { staticClass: "el-icon-top redClass" })
                        : _vm._e(),
                      Number(item.dTrend.qip) >= 0
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  Math.round(
                                    parseFloat(
                                      (item.dTrend.qip * 100).toPrecision(12)
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                      Number(item.dTrend.qip) < 0
                        ? _c("i", { staticClass: "el-icon-bottom greenClass" })
                        : _vm._e(),
                      Number(item.dTrend.qip) < 0
                        ? _c("span", [
                            _vm._v(
                              " -" +
                                _vm._s(
                                  Math.round(
                                    Math.abs(
                                      parseFloat(
                                        (item.dTrend.qip * 100).toPrecision(12)
                                      )
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _c("td", { staticStyle: { width: "120px" } }, [
                      Number(item.dTrend.feedback) > 0
                        ? _c("i", { staticClass: "el-icon-top redClass" })
                        : _vm._e(),
                      Number(item.dTrend.feedback) >= 0
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  Math.round(
                                    parseFloat(
                                      (item.dTrend.feedback * 100).toPrecision(
                                        12
                                      )
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                      Number(item.dTrend.feedback) < 0
                        ? _c("i", { staticClass: "el-icon-bottom greenClass" })
                        : _vm._e(),
                      Number(item.dTrend.feedback) < 0
                        ? _c("span", [
                            _vm._v(
                              " -" +
                                _vm._s(
                                  Math.round(
                                    Math.abs(
                                      parseFloat(
                                        (
                                          item.dTrend.feedback * 100
                                        ).toPrecision(12)
                                      )
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      Number(item.dTrend.sensory) > 0
                        ? _c("i", { staticClass: "el-icon-top redClass" })
                        : _vm._e(),
                      Number(item.dTrend.sensory) >= 0
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  Math.round(
                                    parseFloat(
                                      (item.dTrend.sensory * 100).toPrecision(
                                        12
                                      )
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                      Number(item.dTrend.sensory) < 0
                        ? _c("i", { staticClass: "el-icon-bottom greenClass" })
                        : _vm._e(),
                      Number(item.dTrend.sensory) < 0
                        ? _c("span", [
                            _vm._v(
                              " -" +
                                _vm._s(
                                  Math.round(
                                    Math.abs(
                                      parseFloat(
                                        (item.dTrend.sensory * 100).toPrecision(
                                          12
                                        )
                                      )
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _c("td", { staticStyle: { width: "140px" } }, [
                      Number(item.dTrend.consumerFeedback) > 0
                        ? _c("i", { staticClass: "el-icon-top redClass" })
                        : _vm._e(),
                      Number(item.dTrend.consumerFeedback) >= 0
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  Math.round(
                                    parseFloat(
                                      (
                                        item.dTrend.consumerFeedback * 100
                                      ).toPrecision(12)
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                      Number(item.dTrend.consumerFeedback) < 0
                        ? _c("i", { staticClass: "el-icon-bottom greenClass" })
                        : _vm._e(),
                      Number(item.dTrend.consumerFeedback) < 0
                        ? _c("span", [
                            _vm._v(
                              " -" +
                                _vm._s(
                                  Math.round(
                                    Math.abs(
                                      parseFloat(
                                        (
                                          item.dTrend.consumerFeedback * 100
                                        ).toPrecision(12)
                                      )
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _c("td", { staticStyle: { width: "70px" } }, [
                      Number(item.dTrend.dqmp) > 0
                        ? _c("i", { staticClass: "el-icon-top redClass" })
                        : _vm._e(),
                      Number(item.dTrend.dqmp) >= 0
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  Math.round(
                                    parseFloat(
                                      (item.dTrend.dqmp * 100).toPrecision(12)
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                      Number(item.dTrend.dqmp) < 0
                        ? _c("i", { staticClass: "el-icon-bottom greenClass" })
                        : _vm._e(),
                      Number(item.dTrend.dqmp) < 0
                        ? _c("span", [
                            _vm._v(
                              " -" +
                                _vm._s(
                                  Math.round(
                                    Math.abs(
                                      parseFloat(
                                        (item.dTrend.dqmp * 100).toPrecision(12)
                                      )
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _c("td", { staticStyle: { width: "120px" } }, [
                      Number(item.dTrend.rmcChick) > 0
                        ? _c("i", { staticClass: "el-icon-top redClass" })
                        : _vm._e(),
                      Number(item.dTrend.rmcChick) >= 0
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  Math.round(
                                    parseFloat(
                                      (item.dTrend.rmcChick * 100).toPrecision(
                                        12
                                      )
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                      Number(item.dTrend.rmcChick) < 0
                        ? _c("i", { staticClass: "el-icon-bottom greenClass" })
                        : _vm._e(),
                      Number(item.dTrend.rmcChick) < 0
                        ? _c("span", [
                            _vm._v(
                              " -" +
                                _vm._s(
                                  Math.round(
                                    Math.abs(
                                      parseFloat(
                                        (
                                          item.dTrend.rmcChick * 100
                                        ).toPrecision(12)
                                      )
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _c("td", { staticStyle: { width: "120px" } }, [
                      Number(item.dTrend.rmcProduce) > 0
                        ? _c("i", { staticClass: "el-icon-top redClass" })
                        : _vm._e(),
                      Number(item.dTrend.rmcProduce) >= 0
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  Math.round(
                                    parseFloat(
                                      (
                                        item.dTrend.rmcProduce * 100
                                      ).toPrecision(12)
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                      Number(item.dTrend.rmcProduce) < 0
                        ? _c("i", { staticClass: "el-icon-bottom greenClass" })
                        : _vm._e(),
                      Number(item.dTrend.rmcProduce) < 0
                        ? _c("span", [
                            _vm._v(
                              " -" +
                                _vm._s(
                                  Math.round(
                                    Math.abs(
                                      parseFloat(
                                        (
                                          item.dTrend.rmcProduce * 100
                                        ).toPrecision(12)
                                      )
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _c("td", { staticStyle: { width: "120px" } }, [
                      Number(item.dTrend.antiChick) > 0
                        ? _c("i", { staticClass: "el-icon-top redClass" })
                        : _vm._e(),
                      Number(item.dTrend.antiChick) >= 0
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  Math.round(
                                    parseFloat(
                                      (item.dTrend.antiChick * 100).toPrecision(
                                        12
                                      )
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                      Number(item.dTrend.antiChick) < 0
                        ? _c("i", { staticClass: "el-icon-bottom greenClass" })
                        : _vm._e(),
                      Number(item.dTrend.antiChick) < 0
                        ? _c("span", [
                            _vm._v(
                              " -" +
                                _vm._s(
                                  Math.round(
                                    Math.abs(
                                      parseFloat(
                                        (
                                          item.dTrend.antiChick * 100
                                        ).toPrecision(12)
                                      )
                                    )
                                  )
                                ) +
                                "% "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                ]),
              ]
            )
          }),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "对比情况",
            visible: _vm.dialogVisible,
            width: "70%",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _vm.dialogVisible
            ? _c("div", {
                ref: "Echart",
                staticStyle: { width: "100%", height: "500px" },
                attrs: { id: "barChart" },
              })
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }